import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import Decimal from 'decimal.js';
import { relationshipDisplayedTitle } from '~/business-logic/relationshipLogic';
export class FutureInvoiceModel {
    static fromDTO(dto) {
        return new FutureInvoiceModel(dto);
    }
    compoundId() {
        return "".concat(this.data.relationshipId, "-").concat(this.data.issueDate);
    }
    relationshipId() {
        return this.data.relationshipId;
    }
    customerId() {
        return this.data.customerId;
    }
    companyName() {
        return this.data.companyName;
    }
    agreementName() {
        return this.data.agreementName;
    }
    displayedAgreementName() {
        return relationshipDisplayedTitle(this.data.agreementName, this.data.companyName);
    }
    dueDate() {
        return this.data.dueDate;
    }
    issueDate() {
        return this.data.issueDate;
    }
    requiresApproval() {
        return this.data.requiresApproval;
    }
    total() {
        return this.data.total;
    }
    rawTotal() {
        return this.data.rawTotal;
    }
    rawIssueDate() {
        return this.data.rawIssueDate;
    }
    rawDueDate() {
        return this.data.rawDueDate;
    }
    constructor(data){
        _define_property(this, "data", void 0);
        this.data = _object_spread_props(_object_spread({}, data), {
            rawTotal: new Decimal(data.rawTotal)
        });
    }
}
